import { useState, useEffect } from "react";
import axios from "axios";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Chatbot from "@/components/ChatbotAgentic";
import ServiceUnavailableBanner from "@/components/ServiceUnavailableBanner";
import RancangBangunVideo from "@/components/video/RancangBangunVideo";

function App() {
  const [chatOpen, setChatOpen] = useState(false);
  const [dbUnavailable, setDbUnavailable] = useState(false);

  useEffect(() => {
    // Intercept any 503 response from the backend and surface a banner.
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 503) {
          setDbUnavailable(true);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, []);

  return (
    <div className="App">
      {dbUnavailable && (
        <ServiceUnavailableBanner onDismiss={() => setDbUnavailable(false)} />
      )}
      <BrowserRouter>
        <Routes>
          <Route path="/video" element={<RancangBangunVideo />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<Dashboard />} />
          <Route path="/app/*" element={<Dashboard />} />
        </Routes>
        {/* The video is a fixed composition; keep app chrome out of its frame. */}
        {window.location.pathname !== "/video" && (
          <Chatbot isOpen={chatOpen} setIsOpen={setChatOpen} />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
